import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Workload from "@/pages/Workload";
import Timesheet from "@/pages/Timesheet";
import Staff from "@/pages/Staff";

const Gate = ({ children, adminOnly = false, allowedRoles = null }) => {
  const { user } = useAuth();
  if (user === null)
    return (
      <div data-testid="auth-loading" className="flex min-h-screen items-center justify-center text-sm text-zinc-500">
        Loading…
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  if (allowedRoles && !allowedRoles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};

const LoginGate = () => {
  const { user } = useAuth();
  if (user && user !== true) return <Navigate to="/" replace />;
  return <Login />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginGate />} />
          <Route
            element={
              <Gate>
                <Layout />
              </Gate>
            }
          >
            <Route path="/" element={<Dashboard />} />
            <Route path="/workload" element={<Workload />} />
            <Route path="/timesheet" element={<Timesheet />} />
            <Route
              path="/staff"
              element={
                <Gate allowedRoles={["admin", "supervisor"]}>
                  <Staff />
                </Gate>
              }
            />
          </Route>
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
